<script>



export default {
  data() {
    return {

    };
  },
  mounted() {

    console.log("AuthLogout");

    this.$store.dispatch("auth/logout").then(() => {
      this.$router.push({
        name: "AuthLogin",
        params: { org_code: this.$route.params.org_code },
        query: { logoutSuccess: "1" },
      });
    });
  },

};
</script>
